// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './public-path'
import 'babel-polyfill'
import './util/stringUtil'
import './util/arrayUtil'
import './util/rem'
import 'mint-ui/lib/style.css'
import 'swiper/dist/css/swiper.css'
import '@/assets/css/main.scss'
import Vue from 'vue'
import router from '@/router/router'
import store from '@/store/'
import alert from '@/components/common/alert'
import confirm from '@/components/common/confirm'
import loading from '@/components/common/loading'
import toast from '@/components/common/toast'
import dialog from '@/components/common/dialog'
import MintUI from 'mint-ui'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import Icon from 'vue2-svg-icon/Icon.vue'
import UIP2 from '@/util/uip'
import { getCookie } from '@/util/util'
import Meta from 'vue-meta'
import App from './App.vue'
import codebugPlugin from '@/util/codebug'

// 神策sdk初始化
UIP2.sensor.init(
    {
        platform_type: 'Web',
        platform_name: 'OWF_MB',
        env: 'production'
        // env: window.env === 'PROD' ? 'production' : 'test'
    },
    {
        system_code: 'ESG-OWF-CORE'
    }
)

// 增加神策 通用属性字段
UIP2.sensor.addAttribute({
    application_uid: getCookie('loginUser'),
    is_login: false // 是否登录判定已登录界面真实登录为基准值
})

Vue.component('Icon', Icon)

Vue.use(alert)
Vue.use(confirm)
Vue.use(loading)
Vue.use(toast)
Vue.use(dialog)
Vue.use(MintUI)
Vue.use(VueAwesomeSwiper)
// 使用vue-meta
Vue.use(Meta)
Vue.use(codebugPlugin)

if (window.UIP) {
    const { U, I, P } = new window.UIP()
    Vue.prototype.$U = U
    Vue.prototype.$I = I
    Vue.prototype.$P = P
}

// 因低版本浏览器不支持promise的finally方法，故引入对应的shim: npm i promise.prototype.finally
require('promise.prototype.finally').shim()

Vue.config.productionTip = false

// todo 多国语言
window._ll = Vue.prototype._ll = function (key) {
    const msg = window.i18n
    if (msg && msg[key] && msg[key][window.lang]) {
        return msg[key][window.lang]
    }
    return key
}

new Vue({
    router,
    store,
    render: h => h(App),
    metaInfo() {
        return {
            title: this.$store.state.metaInfo.title,
            meta: [
                {
                    name: 'keywords',
                    content: this.$store.state.metaInfo.keywords
                },
                {
                    name: 'description',
                    content: this.$store.state.metaInfo.description
                }
            ]
        }
    }
}).$mount('#app')

/**
 * 处理iOS 微信客户端6.7.4 键盘收起页面未下移bug
 */

if (/iphone|ipod|ipad/i.test(navigator.appVersion)) {
    document.addEventListener(
        'blur',
        function (e) {
            // 这里加了个类型判断，因为a等元素也会触发blur事件
            const names = ['input', 'textarea']
            setTimeout(function () {
                if (names.indexOf(e.target.localName) > -1) {
                    document.body.scrollIntoView(false)
                }
            }, 100)
        },
        true
    )
}



// WEBPACK FOOTER //
// ./src/main.js